module.exports = __webpack_public_path__ + "static/media/ntakos_thumb1.4a42f84b.jpg";